<template>
  <div class="service_manage" >
    <el-divider content-position="left">单品类型管理列表</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <a href="/product_type">
          <el-button type="warning" size="small">新增单品类型</el-button>
        </a>
        <el-button type="primary" size="small" @click="handleAddOpenItem">新增单品</el-button>
        <el-button style="margin-left: 0;" type="success" size="small" @click="openDlsi_manage">单品管理</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table height="calc(100vh - 250px)" border :data="optionItem" size="medium" style="width: 100%">
      <el-table-column label='id' fixed>
        <template slot-scope="scope">
          {{ scope.row.item_id }}
        </template>
      </el-table-column>
      <el-table-column label='产品类型' width="150" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.type_name" placement="top">
            <span class="count_style" style="display: inherit; cursor: pointer">{{ scope.row.type_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='单品名称' width="150" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.item_name" placement="top">
            <span class="count_style" style="display: inherit; cursor: pointer">{{ scope.row.item_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='单品内容' width="150">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.item_content" placement="top">
            <span class="count_style" style="display: inherit; cursor: pointer">{{ scope.row.item_content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='单品价格'>
        <template slot-scope="scope">
          {{ scope.row.item_price }}
        </template>
      </el-table-column>
      <el-table-column label='单品提成'>
        <template slot-scope="scope">
          {{ scope.row.item_royalty }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="150">
        <template slot-scope="scope">
          <el-input type="number" size="mini" v-model="scope.row.sort" @blur="setSort(scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label='是否含注册' width="100">
        <template slot-scope="scope">
          {{ scope.row.item_include_reg === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含代理记账' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_agency === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税务报到' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_report === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含银行开户' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_open_bank === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税盘托管' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_plate === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含社保开户' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_open === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含公积金开户' width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_open === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税控代办' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_ensure_agent === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税控托管' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_ensure_hosting === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含注册地址' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_address === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含工商变更' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_industry_change === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税务变更' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_change === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含银行变更' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_bank_change === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含社保变更' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_change === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含公积金变更' width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_change === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含工商注销' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_industry_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含税务注销' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含银行注销' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_bank_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含社保注销' width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含公积金注销' width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label='是否含许可证注销' width="140">
        <template slot-scope="scope">
          {{ scope.row.is_licence_logout === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditItem(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-popconfirm @onConfirm="handleDeleteItem(scope.$index, scope.row.item_id)" confirmButtonText='确定'
            cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="这是一段内容确定删除吗？">
            <el-button size="mini" type="danger" slot="reference">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--    页码-->
    <!-- <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOptionItem.currentPage" :page-sizes="[10, 20]" :page-size="pageOptionItem.pageSize"
      :total="pageOptionItem.total" @size-change="handleSizeChangeItem" @current-change="handleCurrentChangeItem">
    </el-pagination> -->
    <!--    添加-->
    <el-drawer title="添加" :visible.sync="AddDrawerItem" :direction="direction" :before-close="handleClose" size="50%">
      <div class="m-tabs-content">
        <el-row>
          <el-divider content-position="left">基础信息</el-divider>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">产品类型</el-col>
          <el-col :span="8" :offset="1">
            <el-select v-model="addDataItem.type_id" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="loadCategory">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.type_name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">单品名称</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品名称" :size="inputSize" v-model="addDataItem.item_name" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">单品价格</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品价格" :size="inputSize" v-model="addDataItem.item_price" clearable>
            </el-input>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">单品提成</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品提成" :size="inputSize" v-model="addDataItem.item_royalty" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">单品内容</el-col>
          <el-col :span="21" :offset="1">
            <el-input type="textarea" :rows="3" placeholder="请输入单品内容" :size="inputSize" v-model="addDataItem.item_content"
              clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">企业新设</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公司注册</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.item_include_reg" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">注册地址</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_address" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_open_bank" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">咨询与提醒</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">一对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.one_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">多对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.many_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">专属财务服务群</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.spec_accountant" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">短信提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.msg_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">邮件提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.email_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公众号提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.public_notice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">基础财税服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税务报到</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_tax_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_secuity_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_accum_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税盘代办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_ensure_agent" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">初始建账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.init_build_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">旧账导入</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.old_tax_import" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">企业年报公示</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.annl_show" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">年度汇算清缴</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.annl_pay" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">记账报税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">代理记账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_agency" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">银行明细信息录入(对账单/回单)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.bank_rec_add" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">人员工资</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.persionel_salary" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">人员工资测算</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.persionel_calculate" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">扣缴税款</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.tax_withholding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">纳税申报</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.tax_return" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">出具财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.financial_statements" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">编制财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.add_financial_excel" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">社保托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.social_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公积金托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.fund_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税盘托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_ensure_hosting" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">全电发票</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.electric_invoice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">发票管理服务</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.invoice_manage" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税控解锁</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.tax_unlock" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">凭证服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证装订</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.voucher_binding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证代存</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.voucher_save" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证代存年末装订总账明细账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.total_account" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证快递费</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.voucher_exp" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">智能财税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">手机查账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.tel_seek_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">客户服务端(小程序会员)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.client_mini" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.financial_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务风险报告</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.tax_risk" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">许可证业务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证新办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.license_new" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">许可证变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.license_modify" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_licence_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司变更相关</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_industry_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_tax_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_bank_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_secuity_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_accum_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司注销</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_industry_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_tax_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_bank_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_secuity_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataItem.is_accum_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddItem">添加</el-button>
        </div>
      </div>
    </el-drawer>
    <!--    编辑-->
    <el-drawer title="编辑" :visible.sync="saveDrawerItem" :direction="direction" :before-close="handleSaveDrawerClose"
      size="50%">
      <div class="m-tabs-content">
        <el-row>
          <el-divider content-position="left">基础信息</el-divider>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">产品类型</el-col>
          <el-col :span="8" :offset="1">
            <el-select v-model="saveDataItem.type_id" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="loadCategory">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.type_name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">单品名称</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品名称" :size="inputSize" v-model="saveDataItem.item_name" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">单品价格</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品价格" :size="inputSize" v-model="saveDataItem.item_price" clearable>
            </el-input>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">单品提成</el-col>
          <el-col :span="8" :offset="1">
            <el-input placeholder="请输入单品提成" :size="inputSize" v-model="saveDataItem.item_royalty" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2" class="m-label">单品内容</el-col>
          <el-col :span="21" :offset="1">
            <el-input type="textarea" :rows="3" placeholder="请输入单品内容" :size="inputSize"
              v-model="saveDataItem.item_content" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">企业新设</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公司注册</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.item_include_reg" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">注册地址</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_address" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_open_bank" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">咨询与提醒</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">一对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.one_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">多对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.many_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">专属财务服务群</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.spec_accountant" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">短信提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.msg_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">邮件提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.email_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公众号提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.public_notice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">基础财税服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税务报到</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_tax_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_secuity_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_accum_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税盘代办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_ensure_agent" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">初始建账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.init_build_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">旧账导入</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.old_tax_import" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">企业年报公示</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.annl_show" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">年度汇算清缴</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.annl_pay" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">记账报税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">代理记账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_agency" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">银行明细信息录入(对账单/回单)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.bank_rec_add" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">人员工资</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.persionel_salary" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">人员工资测算</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.persionel_calculate" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">扣缴税款</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.tax_withholding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">纳税申报</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.tax_return" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">出具财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.financial_statements" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">编制财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.add_financial_excel" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">社保托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.social_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公积金托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.fund_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税盘托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_ensure_hosting" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">全电发票</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.electric_invoice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">发票管理服务</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.invoice_manage" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税控解锁</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.tax_unlock" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">凭证服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证装订</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.voucher_binding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证代存</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.voucher_save" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证代存年末装订总账明细账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.total_account" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证快递费</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.voucher_exp" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">智能财税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">手机查账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.tel_seek_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">客户服务端(小程序会员)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.client_mini" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.financial_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务风险报告</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.tax_risk" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">许可证业务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证新办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.license_new" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">许可证变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.license_modify" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_licence_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司变更相关</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_industry_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_tax_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_bank_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_secuity_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_accum_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司注销</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_industry_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_tax_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_bank_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_secuity_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="saveDataItem.is_accum_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSaveItem">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'service_manage',
  data() {
    return {
      combtype: [],
      categoryIdOptions: [],
      inputSize: 'small',
      optionItem: [],
      pageOptionItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      AddDrawerItem: false,
      saveDrawerItem: false,
      direction: 'rtl',
      addDataItem: {
        item_name: '',
        item_content: '',
        item_price: null,
        item_royalty: null,
        type_id: '',
        item_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        one_to_one: 1,
        many_to_one: 1,
        spec_accountant: 1,
        msg_attention: 1,
        email_attention: 1,
        public_notice: 1,
        voucher_binding: 1,
        voucher_save: 1,
        total_account: 1,
        voucher_exp: 1,
        tel_seek_acc: 1,
        client_mini: 1,
        financial_report: 1,
        tax_risk: 1,
        license_new: 1,
        license_modify: 1,
        init_build_acc: 1,
        old_tax_import: 1,
        annl_show: 1,
        annl_pay: 1,
        bank_rec_add: 1,
        persionel_salary: 1,
        persionel_calculate: 1,
        tax_withholding: 1,
        tax_return: 1,
        financial_statements: 1,
        add_financial_excel: 1,
        social_host: 1,
        fund_host: 1,
        electric_invoice: 1,
        invoice_manage: 1,
        tax_unlock: 1
      },
      saveDataItem: {
        item_id: null,
        item_name: '',
        item_content: '',
        item_price: null,
        item_royalty: null,
        index: null,
        type_id: '',
        item_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        one_to_one: 1,
        many_to_one: 1,
        spec_accountant: 1,
        msg_attention: 1,
        email_attention: 1,
        public_notice: 1,
        voucher_binding: 1,
        voucher_save: 1,
        total_account: 1,
        voucher_exp: 1,
        tel_seek_acc: 1,
        client_mini: 1,
        financial_report: 1,
        tax_risk: 1,
        license_new: 1,
        license_modify: 1,
        init_build_acc: 1,
        old_tax_import: 1,
        annl_show: 1,
        annl_pay: 1,
        bank_rec_add: 1,
        persionel_salary: 1,
        persionel_calculate: 1,
        tax_withholding: 1,
        tax_return: 1,
        financial_statements: 1,
        add_financial_excel: 1,
        social_host: 1,
        fund_host: 1,
        electric_invoice: 1,
        invoice_manage: 1,
        tax_unlock: 1
      }
    }
  },
  computed: {
    pageDataItem: {
      get: function () {
        return this.optionItem.slice(
          this.pageOptionItem.pageSize * (this.pageOptionItem.currentPage - 1),
          this.pageOptionItem.pageSize * this.pageOptionItem.currentPage
        )
      }
    },
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {
    openDlsi_manage() {
      this.$router.push('/dl_si_manage')
    },
    loadCategory() {
      this.$axios
        .get('api/product_type/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data
          }
        })
        .catch()
    },
    combloadCategory() {
      this.$axios
        .get('api/product_type/combgetcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.combtype = data.data
          }
        })
        .catch()
    },
    // 单品类型
    getDataItem() {
      this.$axios.get('/api/itemtype/list').then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.optionItem = data.data
          this.pageOptionItem.total = this.optionItem.length
        }
      })
    },
    handleAddOpenItem() {
      this.AddDrawerItem = true
    },
    handleAddItem() {
      if (!this.addDataItem.type_id) {
        this.$message.error('请选择产品类型')
        return
      }
      if (!this.addDataItem.item_name) {
        this.$message.error('单品名称不能为空')
        return
      }
      if (!this.addDataItem.item_name) {
        this.$message.error('单品内容不能为空')
        return
      }
      this.$axios.post('/api/itemtype/create', this.addDataItem).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.getDataItem()
          this.pageOptionItem.total = this.optionItem.length
          this.$message.success(data.msg)
          this.clearAddItemData()
          this.AddDrawerItem = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    clearAddItemData() {
      this.addDataItem.item_content = ''
      this.addDataItem.item_name = ''
      this.addDataItem.item_price = ''
      this.addDataItem.item_royalty = ''
      this.addDataItem.is_accum_change = 1
      this.addDataItem.is_accum_logout = 1
      this.addDataItem.is_accum_open = 1
      this.addDataItem.is_address = 1
      this.addDataItem.is_agency = 1
      this.addDataItem.is_bank_change = 1
      this.addDataItem.is_bank_logout = 1
      this.addDataItem.is_ensure_agent = 1
      this.addDataItem.is_ensure_hosting = 1
      this.addDataItem.is_industry_change = 1
      this.addDataItem.is_industry_logout = 1
      this.addDataItem.is_licence_logout = 1
      this.addDataItem.is_open_bank = 1
      this.addDataItem.is_secuity_change = 1
      this.addDataItem.is_secuity_logout = 1
      this.addDataItem.is_secuity_open = 1
      this.addDataItem.is_tax_change = 1
      this.addDataItem.is_tax_logout = 1
      this.addDataItem.is_tax_plate = 1
      this.addDataItem.is_tax_report = 1
      this.addDataItem.item_include_reg = 1
      this.addDataItem.one_to_one = 1
      this.addDataItem.many_to_one = 1
      this.addDataItem.spec_accountant = 1
      this.addDataItem.msg_attention = 1
      this.addDataItem.email_attention = 1
      this.addDataItem.public_notice = 1
      this.addDataItem.voucher_binding = 1
      this.addDataItem.voucher_save = 1
      this.addDataItem.total_account = 1
      this.addDataItem.voucher_exp = 1
      this.addDataItem.tel_seek_acc = 1
      this.addDataItem.client_mini = 1
      this.addDataItem.financial_report = 1
      this.addDataItem.tax_risk = 1
      this.addDataItem.license_new = 1
      this.addDataItem.license_modify = 1
      this.addDataItem.init_build_acc = 1
      this.addDataItem.old_tax_import = 1
      this.addDataItem.annl_show = 1
      this.addDataItem.annl_pay = 1
      this.addDataItem.bank_rec_add = 1
      this.addDataItem.persionel_salary = 1
      this.addDataItem.persionel_calculate = 1
      this.addDataItem.tax_withholding = 1
      this.addDataItem.tax_return = 1
      this.addDataItem.financial_statements = 1
      this.addDataItem.add_financial_excel = 1
      this.addDataItem.social_host = 1
      this.addDataItem.fund_host = 1
      this.addDataItem.electric_invoice = 1
      this.addDataItem.invoice_manage = 1
      this.addDataItem.tax_unlock = 1
    },
    handleEditItem(index, row) {
      this.saveDataItem.is_accum_change = row.is_accum_change
      this.saveDataItem.is_accum_logout = row.is_accum_logout
      this.saveDataItem.is_accum_open = row.is_accum_open
      this.saveDataItem.is_address = row.is_address
      this.saveDataItem.is_agency = row.is_agency
      this.saveDataItem.is_bank_change = row.is_bank_change
      this.saveDataItem.is_bank_logout = row.is_bank_logout
      this.saveDataItem.is_ensure_agent = row.is_ensure_agent
      this.saveDataItem.is_ensure_hosting = row.is_ensure_hosting
      this.saveDataItem.is_industry_change = row.is_industry_change
      this.saveDataItem.is_industry_logout = row.is_industry_logout
      this.saveDataItem.is_licence_logout = row.is_licence_logout
      this.saveDataItem.is_open_bank = row.is_open_bank
      this.saveDataItem.is_secuity_change = row.is_secuity_change
      this.saveDataItem.is_secuity_logout = row.is_secuity_logout
      this.saveDataItem.is_secuity_open = row.is_secuity_open
      this.saveDataItem.is_tax_change = row.is_tax_change
      this.saveDataItem.is_tax_logout = row.is_tax_logout
      this.saveDataItem.is_tax_plate = row.is_tax_plate
      this.saveDataItem.is_tax_report = row.is_tax_report
      this.saveDataItem.item_content = row.item_content
      this.saveDataItem.item_include_reg = row.item_include_reg
      this.saveDataItem.item_name = row.item_name
      this.saveDataItem.item_price = row.item_price
      this.saveDataItem.item_royalty = row.item_royalty
      this.saveDataItem.item_id = row.item_id
      this.saveDataItem.index = index
      this.saveDataItem.type_id = row.type_id
      this.saveDataItem.one_to_one = row.one_to_one
      this.saveDataItem.many_to_one = row.many_to_one
      this.saveDataItem.spec_accountant = row.spec_accountant
      this.saveDataItem.msg_attention = row.msg_attention
      this.saveDataItem.email_attention = row.email_attention
      this.saveDataItem.public_notice = row.public_notice
      this.saveDataItem.voucher_binding = row.voucher_binding
      this.saveDataItem.voucher_save = row.voucher_save
      this.saveDataItem.total_account = row.total_account
      this.saveDataItem.voucher_exp = row.voucher_exp
      this.saveDataItem.tel_seek_acc = row.tel_seek_acc
      this.saveDataItem.client_mini = row.client_mini
      this.saveDataItem.financial_report = row.financial_report
      this.saveDataItem.tax_risk = row.tax_risk
      this.saveDataItem.license_new = row.license_new
      this.saveDataItem.license_modify = row.license_modify
      this.saveDataItem.init_build_acc = row.init_build_acc
      this.saveDataItem.old_tax_import = row.old_tax_import
      this.saveDataItem.annl_show = row.annl_show
      this.saveDataItem.annl_pay = row.annl_pay
      this.saveDataItem.bank_rec_add = row.bank_rec_add
      this.saveDataItem.persionel_salary = row.persionel_salary
      this.saveDataItem.persionel_calculate = row.persionel_calculate
      this.saveDataItem.tax_withholding = row.tax_withholding
      this.saveDataItem.tax_return = row.tax_return
      this.saveDataItem.financial_statements = row.financial_statements
      this.saveDataItem.add_financial_excel = row.add_financial_excel
      this.saveDataItem.social_host = row.social_host
      this.saveDataItem.fund_host = row.fund_host
      this.saveDataItem.electric_invoice = row.electric_invoice
      this.saveDataItem.invoice_manage = row.invoice_manage
      this.saveDataItem.tax_unlock = row.tax_unlock
      this.saveDrawerItem = true
    },
    handleSaveItem() {
      if (!this.saveDataItem.item_name) {
        this.$message.error('单品名称不能为空')
        return
      }
      if (!this.saveDataItem.item_content) {
        this.$message.error('单品内容不能为空')
        return
      }
      this.$axios
        .post(
          '/api/itemtype/update/' + this.saveDataItem.item_id,
          this.saveDataItem
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.getDataItem()
            this.$message.success(data.msg)
            this.clearSaveItemData()
            this.saveDrawerItem = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearSaveItemData() {
      this.saveDataItem.item_content = ''
      this.saveDataItem.item_name = ''
      this.saveDataItem.item_price = ''
      this.saveDataItem.item_royalty = ''
      this.saveDataItem.is_accum_change = 1
      this.saveDataItem.is_accum_logout = 1
      this.saveDataItem.is_accum_open = 1
      this.saveDataItem.is_address = 1
      this.saveDataItem.is_agency = 1
      this.saveDataItem.is_bank_change = 1
      this.saveDataItem.is_bank_logout = 1
      this.saveDataItem.is_ensure_agent = 1
      this.saveDataItem.is_ensure_hosting = 1
      this.saveDataItem.is_industry_change = 1
      this.saveDataItem.is_industry_logout = 1
      this.saveDataItem.is_licence_logout = 1
      this.saveDataItem.is_open_bank = 1
      this.saveDataItem.is_secuity_change = 1
      this.saveDataItem.is_secuity_logout = 1
      this.saveDataItem.is_secuity_open = 1
      this.saveDataItem.is_tax_change = 1
      this.saveDataItem.is_tax_logout = 1
      this.saveDataItem.is_tax_plate = 1
      this.saveDataItem.is_tax_report = 1
      this.saveDataItem.item_include_reg = 1
      this.saveDataItem.one_to_one = 1
      this.saveDataItem.many_to_one = 1
      this.saveDataItem.spec_accountant = 1
      this.saveDataItem.msg_attention = 1
      this.saveDataItem.email_attention = 1
      this.saveDataItem.public_notice = 1
      this.saveDataItem.voucher_binding = 1
      this.saveDataItem.voucher_save = 1
      this.saveDataItem.total_account = 1
      this.saveDataItem.voucher_exp = 1
      this.saveDataItem.tel_seek_acc = 1
      this.saveDataItem.client_mini = 1
      this.saveDataItem.financial_report = 1
      this.saveDataItem.tax_risk = 1
      this.saveDataItem.license_new = 1
      this.saveDataItem.license_modify = 1
      this.saveDataItem.init_build_acc = 1
      this.saveDataItem.old_tax_import = 1
      this.saveDataItem.annl_show = 1
      this.saveDataItem.annl_pay = 1
      this.saveDataItem.bank_rec_add = 1
      this.saveDataItem.persionel_salary = 1
      this.saveDataItem.persionel_calculate = 1
      this.saveDataItem.tax_withholding = 1
      this.saveDataItem.tax_return = 1
      this.saveDataItem.financial_statements = 1
      this.saveDataItem.add_financial_excel = 1
      this.saveDataItem.social_host = 1
      this.saveDataItem.fund_host = 1
      this.saveDataItem.electric_invoice = 1
      this.saveDataItem.invoice_manage = 1
      this.saveDataItem.tax_unlock = 1
    },
    handleDeleteItem(index, id) {
      this.handleDeleteSubItem(index, id)
    },
    handleDeleteSubItem(index, id) {
      this.$axios.get('/api/itemtype/delete/' + id).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let idx =
            this.pageOptionItem.pageSize *
            (this.pageOptionItem.currentPage - 1) +
            index
          this.optionItem.splice(idx, 1)
          this.pageOptionItem.total = this.optionItem.length
          if (index === 0) this.prePage(this.pageOptionItem, 'item')
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeItem(val) {
      this.pageOptionItem.pageSize = val
    },
    handleCurrentChangeItem(val) {
      this.pageOptionItem.currentPage = val
    },
    handleSaveDrawerClose(done) {
      this.$confirm('确认关闭?')
        .then((_) => {
          this.clearSaveItemData()
          done()
        })
        .catch((_) => { })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    handleClose_dlsi_manage_drawer(done) {
      done()
    },
    setSort(row) {
      if (isNaN(row.sort - 0)) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/itemtype/setsort', {
          item_id: row.item_id,
          sort: row.sort,
        })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.clearSaveItemData()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
  },
  mounted() {
    this.getDataItem()
    this.loadCategory()
    this.combloadCategory()
  },
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';
@import '~styles/icon.styl';

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-drawer__wrapper >>> .el-drawer__header span {
  color: #4c87fc;
  font-size: 0.36rem;
  font-weight: 400;
}

.service_manage {
  marginLeft();
}

.mt-10 {
  margin-top: 0.2rem;
}

.tr {
  text-align: right;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
  overflow-y: auto;

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}

.service_manage >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.addCon {
  padding: 0.2rem;
  text-align: right;
}

.count_style {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.label-height {
  line-height: 28px
}

</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/DptypeList.vue